import React from "react";
import { INewInvoiceData } from "../../services/dashboard.services";
import ProrationItemLayout from "./ProrationItemLayout";

export default function ProrationData(props: IProps) {
  const { subscription_items } = props.invoiceData;

  return (
    <React.Fragment>
      {subscription_items &&
        subscription_items.map((subItem, index) => {
          return (
            <ProrationItemLayout
              key={subItem.id}
              id={subItem.id}
              currentQuantity={subItem.current_quantity}
              currentAmount={subItem.current_amount}
              newQuantity={subItem.new_quantity}
              newAmount={subItem.new_amount}
              baseAmount={subItem.base_amount}
              productID={subItem.product_id}
              productData={props.productData}
              country={props.country}
            ></ProrationItemLayout>
          );
        })}
    </React.Fragment>
  );
}

interface IProps {
  invoiceData: INewInvoiceData;
  productData: { [key: string]: string };
  country: string;
}
